<template>
  <div>
    <h2>Impressum</h2>
    <p>Angaben zum Dienstanbieter der Webseiten nach dem Telemediengesetz</p>

    <h4>Verantwortliche und Ansprechpartner</h4>
    <h5>Ansprechpartner für Pflege und Aktualisierungen</h5>
    <p>
      Webredaktion des Studiengangs Angewandte Informatik (ai.it.hs-worms.de)<br />
      Für Kommentare, Anmerkungen oder Fehlerkorrekturen schreiben Sie bitte eine E-Mail an die Webredaktion
      <a :href="'mailto:' + impressum.webResponsible.email">{{ impressum.webResponsible.email }}</a>.
    </p>

    <h5>Verantwortlich für das Webangebot des Studiengangs Angewandte Informatik</h5>
    <p>
      {{ impressum.webResponsible.name }}<br />
      <a :href="'mailto:' + impressum.webResponsible.email">{{ impressum.webResponsible.email }}</a><br />
      Hochschule Worms<br />
      Fachbereich Informatik<br />
      Raum {{ impressum.webResponsible.room }}
    </p>

    <h4>Angaben zum Dienstanbieter</h4>
    <p>
      <span v-for="(line, i) in impressum.serviceProvider.addressLines" :key="i">
        {{ line }}<br />
      </span>
      <br />
      Telefon: {{ impressum.serviceProvider.phone }}<br />
      Telefax: {{ impressum.serviceProvider.fax }}<br />
      E-Mail: <a :href="'mailto:' + impressum.serviceProvider.email">{{ impressum.serviceProvider.email }}</a><br />
      Internet: <a :href="'https://' + impressum.serviceProvider.website">{{ impressum.serviceProvider.website }}</a>
      <br /><br />
      Umsatzsteueridentifikationsnummer gemäß §27a Umsatzsteuergesetz: {{ impressum.serviceProvider.vatId }}
      <br /><br />
      {{ impressum.serviceProvider.legalForm }}
    </p>

    <h4>Zuständige Aufsichtsbehörde</h4>
    <p>
      <span v-for="(line, i) in impressum.authorityLines" :key="i">
        {{ line }}<br />
      </span>
    </p>

    <h4>Haftung / Disclaimer</h4>
    <p v-for="(para, i) in impressum.disclaimer" :key="i">{{ para }}</p>

    <h4>Datenschutzerklärung</h4>
    <p>Die Datenschutzerklärung finden Sie unter <a href="http://wetter.hs-worms.de/legal">Datenschutz</a></p>

    <h4>Copyright</h4>
    <p>{{ impressum.copyright }}</p>
  </div>
</template>

<script>
import impressumData from '@/assets/impressum.json'

export default {
  data() {
    return {
      impressum: impressumData
    }
  }
}
</script>